module.exports = __webpack_public_path__ + "img/2.2.6d1c2dc4.svg";